/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_No_PaymentsInputs */

const en_admin_payments_no_payments = /** @type {(inputs: Admin_Payments_No_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payments yet`)
};

/**
* | output |
* | --- |
* | "No payments yet" |
*
* @param {Admin_Payments_No_PaymentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_no_payments = /** @type {((inputs?: Admin_Payments_No_PaymentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_No_PaymentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_no_payments(inputs)
});
export { admin_payments_no_payments as "admin.payments.no_payments" }